import React from "react";
import PageContent from "../shared/PageContent/PageContent";
import CompanyDownlineCard from "../Company/CompanyDownlineCard";
import "./DashboardPage.css";

function CompanyAdminDashboard() {
  return (
    <PageContent>
      <CompanyDownlineCard />
    </PageContent>
  );
}

export default CompanyAdminDashboard;
